<script setup lang="ts">
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import type { BulkExportResult } from '@/composables/useBulkExport';

interface Props {
  isExporting: boolean;
  progressLabel: string;
  lastResult: BulkExportResult | null;
  lastErrorMessage: string | null;
}

const props = defineProps<Props>();

const { t } = useI18n();

const successSnackbar = ref(false);
const warningSnackbar = ref(false);
const errorSnackbar = ref(false);

watch(() => props.lastResult, (result) => {
  successSnackbar.value = result === 'success';
  warningSnackbar.value = result === 'warning';
  errorSnackbar.value = result === 'error';
});
</script>
<template>
  <v-snackbar
    :model-value="isExporting"
    :timeout="-1"
    color="primary"
    rounded="pill"
  >
    {{ progressLabel ?
      t('bulkExports.generating', { progress: progressLabel }) :
      t('bulkExports.started') }}
  </v-snackbar>
  <v-snackbar
    v-model="successSnackbar"
    :timeout="4000"
    color="success"
    rounded="pill"
  >
    {{ t('bulkExports.completed') }}
  </v-snackbar>
  <v-snackbar
    v-model="warningSnackbar"
    :timeout="8000"
    color="warning"
    rounded="pill"
  >
    {{ t('bulkExports.completedWithSkips', { message: lastErrorMessage }) }}
  </v-snackbar>
  <v-snackbar
    v-model="errorSnackbar"
    :timeout="6000"
    color="error"
    rounded="pill"
  >
    {{ t('bulkExports.failed') }}
  </v-snackbar>
</template>
